import React from 'react';
import {
  Link
} from "react-router-dom";

class CountryCard extends React.Component {
  render() {
    const country = this.props.country;
    const theme = this.props.theme;
    const formattedPopulation = Intl.NumberFormat('tr-TR').format(country.population);
    return (
      theme ?
        <div className="country-card bg-white flex flex-col mt-8 rounded-md shadow-md transition-colors 
        transition-transform duration-300 transform hover:scale-105 md:w-1/3 lg:w-1/4 xl:w-1/5">
          <div className="flag min-w-full h-32 sm:h-56 md:h-40 lg:h-32">
            <img src={country.flag} alt="country flag" className="w-full h-full rounded-tl-md rounded-tr-md object-cover" />
          </div>
          <div className="flex flex-col p-4">
            <Link to={`/countries/${country.name}`}>
              <h6 className="text-sm font-bold sm:text-lg md:text-xl lg:text-lg cursor-pointer hover:underline">{country.name}</h6>
            </Link>
            <div className="flex justify-start mt-4">
              <h6 className="text-xs font-bold mr-1 sm:text-base md:text-lg lg:text-sm">Population: </h6>
              <p className="text-xs sm:text-base md:text-lg lg:text-sm"> {formattedPopulation} </p>
            </div>
            <div className="flex justify-start mt-1">
              <h6 className="text-xs font-bold mr-1 sm:text-base md:text-lg lg:text-sm">Region: </h6>
              <p className="text-xs sm:text-base md:text-lg lg:text-sm"> {country.region} </p>
            </div>
            <div className="flex justify-start mt-1">
              <h6 className="text-xs font-bold mr-1 sm:text-base md:text-lg lg:text-sm">Capital: </h6>
              <p className="text-xs sm:text-base md:text-lg lg:text-sm"> {country.capital} </p>
            </div>
          </div>
        </div> :
        <div className="country-card bg-gray-800 flex flex-col mt-8 rounded-md shadow-md  transition-colors 
        transition-transform duration-300 transform hover:scale-105 md:w-1/3 lg:w-1/4 xl:w-1/5">
          <div className="flag min-w-full h-32 sm:h-56 md:h-40 lg:h-32">
            <img src={country.flag} alt="country flag" className="w-full h-full rounded-tl-md rounded-tr-md object-cover" />
          </div>
          <div className="flex flex-col p-4">
            <Link to={`/countries/${country.name}`}>
              <h6 className="text-sm text-gray-400 font-bold sm:text-lg md:text-xl lg:text-lg cursor-pointer hover:underline">{country.name}</h6>
            </Link>
            <div className="flex justify-start mt-4">
              <h6 className="text-gray-400 text-xs font-bold mr-1 sm:text-base md:text-lg lg:text-sm">Population: </h6>
              <p className="text-gray-400 text-xs sm:text-base md:text-lg lg:text-sm"> {formattedPopulation} </p>
            </div>
            <div className="flex justify-start mt-1">
              <h6 className="text-gray-400 text-xs font-bold mr-1 sm:text-base md:text-lg lg:text-sm">Region: </h6>
              <p className="text-gray-400 text-xs sm:text-base md:text-lg lg:text-sm"> {country.region} </p>
            </div>
            <div className="flex justify-start mt-1">
              <h6 className="text-gray-400 text-xs font-bold mr-1 sm:text-base md:text-lg lg:text-sm">Capital: </h6>
              <p className="text-gray-400 text-xs sm:text-base md:text-lg lg:text-sm"> {country.capital} </p>
            </div>
          </div>
        </div>
    );
  }
}

export default CountryCard;
